import DataMain from '@/data/dataMain'
import idbs from '@/data/indexedDBService'
import {store} from '@/store'
import {format as dateFnsformat, subDays, isFirstDayOfMonth} from 'date-fns'

const DataActivities = {
  async setActive (activity, active) {
    let activeNumber = 0
    if (active) { activeNumber = 1 }
    let params = {
      APIParams: {
        'on': active, 'id': activity
      },
      slug: 'api/activities/setactive',
      storeInfo: {
        action: 'setActive',
        params: {
          id: activity,
          active: active
        }
      },
      idbInfo: {
        store: 'activities',
        storeKey: 'activities',
        indexName: 'id',
        key: activity,
        params: {
          id: activity,
          active: activeNumber
        }
      }
    }
    DataMain.setData(params)
  },

  async deleteActivity (activity) {
    let params = {
      APIParams: {
        'id': activity
      },
      slug: 'api/activities/delete',
      storeInfo: {
        action: 'deleteActivity',
        params: {
          id: activity
        }
      },
      idbInfo: {
        store: 'activities',
        storeKey: 'activities',
        action: 'delete',
        indexName: 'id',
        key: activity,
        params: {
          id: activity
        }
      }
    }
    DataMain.setData(params)
  },

  async addActivity (activityName) {
    let params = {
      APIParams: {
        'title': activityName
      },
      APICallback: {
        'function': 'DataMain.ReplaceTemporary'
      },
      slug: 'api/activities/add',
      temporary: true,
      storeInfo: {
        action: 'addActivity',
        params: {
          activity: {
            title: activityName,
            active: 1
          }
        }
      },
      idbInfo: {
        store: 'activities',
        storeKey: 'activities',
        indexName: 'id',
        key: 'temporary',
        params: {
          title: activityName,
          active: 1
        }
      }
    }
    DataMain.setData(params)
  },

  async updateActivity (activity) {
    let params = {
      APIParams: {
        'id': activity.id, 'title': activity.title
      },
      slug: 'api/activities/update',
      storeInfo: {
        action: 'updateActivity',
        params: {
          id: activity.id,
          title: activity.title
        }
      },
      idbInfo: {
        store: 'activities',
        storeKey: 'activities',
        indexName: 'id',
        key: activity.id,
        params: {
          id: activity.id,
          title: activity.title
        }
      }
    }
    DataMain.setData(params)
  },

  async toggleActivity (obj) {
    let monthYear = obj.date.slice(0, -3)
    let params = {
      APIParams: {
        'date': obj.date, 'on': obj.on, 'id': obj.id
      },
      slug: 'api/activities/track',
      storeInfo: {
        action: 'toggleActivity',
        params: {
          obj: obj
        }
      },
      idbInfo: {
        storeKey: 'month-' + monthYear
      }
    }
    if (obj.date) {
      let data = await idbs.getItem('trackActivities', 'date', obj.date)
      let arr = []
      if (data && data.activities) {
        arr = data.activities
      }
      if (obj.on) {
        arr.push(obj.id)
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] === [obj.id] * 1) {
            arr.splice(i, 1)
          }
        }
      }
      idbs.saveToStorage('trackActivities', {
        date: obj.date,
        activities: arr
      })
    }
    DataMain.setData(params)
  },

  calculateStreak (params) {
    let trackActivities = store.state.trackActivities.activities
    let activityTracking = store.state.trackActivities.activities[params.activity]
    let today = params.date
    let active = today
    let yesterday = dateFnsformat(subDays(today, 1), 'YYYY-MM-DD')
    let yesterdayMonth = dateFnsformat(yesterday, 'YYYY-MM')
    let streakEnd = false
    if (isFirstDayOfMonth(today) && !store.state.trackActivities.monthsTracked.includes(yesterdayMonth)) {
      DataMain.getMonth(yesterday)
    }

    if (!trackActivities || !activityTracking || (!activityTracking.includes(today) && !activityTracking.includes(yesterday))) {
      return false
    }
    if (trackActivities && activityTracking) {
      if (activityTracking.includes(today)) {
        streakEnd = 'today'
      } else if (activityTracking.includes(yesterday)) {
        streakEnd = 'yesterday'
        active = yesterday
      } else {
        return false
      }
    }
    let days = 1
    let oldactive = active
    let activeMonth = false
    while (days < 1000) {
      oldactive = active
      active = dateFnsformat(subDays(active, 1), 'YYYY-MM-DD')
      activeMonth = dateFnsformat(active, 'YYYY-MM')
      if (isFirstDayOfMonth(oldactive) && !store.state.trackActivities.monthsTracked.includes(activeMonth)) {
        console.log('getting last month')
        DataMain.getMonth(active)
      }

      if (!activityTracking.includes(active)) {
        break
      }
      days++
    }
    if (days === 999) { days = '999+' }

    let data = {
      streakEnd: streakEnd,
      days: days
    }
    return data
  }
}

export default DataActivities



// WEBPACK FOOTER //
// ./src/data/controllers/DataActivities.js